export const SPECIAL_EVENT_PAGE_NAME = 'TruckMonth';
export const SPECIAL_EVENT_TARGET = "https://www.buyfordnow.com/salesevent";